// SEO dynamique par page (SPA) — titre, description, canonical, Open Graph, JSON-LD.
const BASE = "https://bougieducoeur.com";

const DEFAULTS = {
  title: "BougieDuCœur — En mémoire de ceux qui nous manquent",
  description: "BougieDuCœur — Allumez une bougie virtuelle en mémoire d'un être cher.",
  image: `${BASE}/og-image.png`,
};

function setMeta(attr, key, content) {
  let el = document.head.querySelector(`meta[${attr}="${key}"]`);
  if (!content) return;
  if (!el) {
    el = document.createElement("meta");
    el.setAttribute(attr, key);
    document.head.appendChild(el);
  }
  el.setAttribute("content", content);
}

function setLink(rel, href) {
  let el = document.head.querySelector(`link[rel="${rel}"]`);
  if (!el) {
    el = document.createElement("link");
    el.setAttribute("rel", rel);
    document.head.appendChild(el);
  }
  el.setAttribute("href", href);
}

// hreflang code map : clé i18n interne -> code hreflang IETF valide.
const HREFLANG = {
  fr: "fr", en: "en", es: "es", es_mx: "es-MX", de: "de", it: "it",
  pl: "pl", fil: "fil", ru: "ru", el: "el", hi: "hi", ja: "ja", zh: "zh",
};

export function setHtmlLang(lng) {
  const code = HREFLANG[lng] || (lng || "fr").replace("_", "-");
  document.documentElement.setAttribute("lang", code);
}

function clearAlternates() {
  document.querySelectorAll('link[data-bdc-alt]').forEach((n) => n.remove());
}

// alternates : [{ lang: "fr", href: "https://.../toussaint?lang=fr" }, ...]
// xDefault : URL par défaut (facultatif).
export function setHreflangAlternates(alternates, xDefault) {
  clearAlternates();
  (alternates || []).forEach(({ lang, href }) => {
    const el = document.createElement("link");
    el.rel = "alternate";
    el.hreflang = HREFLANG[lang] || lang;
    el.href = href;
    el.setAttribute("data-bdc-alt", "1");
    document.head.appendChild(el);
  });
  if (xDefault) {
    const el = document.createElement("link");
    el.rel = "alternate";
    el.hreflang = "x-default";
    el.href = xDefault;
    el.setAttribute("data-bdc-alt", "1");
    document.head.appendChild(el);
  }
}

export function setPageSeo({ title, ogTitle, description, ogDescription, canonicalPath, image, imageWidth, imageHeight, jsonLd, ogType, alternates, xDefault }) {
  if (title) document.title = title;
  setMeta("name", "description", description);
  setMeta("property", "og:title", ogTitle || title);
  setMeta("property", "og:description", ogDescription || description);
  setMeta("property", "og:type", ogType || "article");
  if (image) {
    setMeta("property", "og:image", image);
    setMeta("property", "og:image:width", imageWidth || "1200");
    setMeta("property", "og:image:height", imageHeight || "630");
    setMeta("name", "twitter:image", image);
    setMeta("name", "twitter:card", "summary_large_image");
  }
  setMeta("name", "twitter:title", ogTitle || title);
  setMeta("name", "twitter:description", ogDescription || description);
  if (canonicalPath) {
    const url = canonicalPath.startsWith("http") ? canonicalPath : BASE + canonicalPath;
    setLink("canonical", url);
    setMeta("property", "og:url", url);
  }
  if (alternates) setHreflangAlternates(alternates, xDefault);
  let s = document.getElementById("bdc-jsonld");
  if (jsonLd) {
    if (!s) {
      s = document.createElement("script");
      s.type = "application/ld+json";
      s.id = "bdc-jsonld";
      document.head.appendChild(s);
    }
    s.textContent = JSON.stringify(jsonLd);
  } else if (s) {
    s.remove();
  }
}

export function resetPageSeo() {
  document.title = DEFAULTS.title;
  setMeta("name", "description", DEFAULTS.description);
  setMeta("property", "og:title", DEFAULTS.title);
  setMeta("property", "og:description", DEFAULTS.description);
  setMeta("property", "og:type", "website");
  setMeta("property", "og:image", DEFAULTS.image);
  setLink("canonical", `${BASE}/`);
  setMeta("property", "og:url", `${BASE}/`);
  const s = document.getElementById("bdc-jsonld");
  if (s) s.remove();
  clearAlternates();
}

export { BASE as SEO_BASE };
